<template>
  <path
    d="M12.29 8.7103L9.7 11.3003C9.31 11.6903 9.31 12.3203 9.7 12.7103L12.29 15.3003C12.92 15.9303 14 15.4803 14 14.5903V9.4103C14 8.5203 12.92 8.0803 12.29 8.7103Z"
  />
</template>
